import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Header from "../../layouts/Header";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import "../../assets/styles/local/OrderPickingList.css";
import "../../assets/styles/local/asc_Custom_Select_Box.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { AddOrderPicking, FetchMaterialList } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { ADD_ORDER_PICKING } from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";

const OrderPickingFromProject = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const addOrderPickingRes = useSelector(
    (state) => state.user.addOrderPickingRes
  );

  const location = useLocation();
  const projectId = location.state?.projectId;
  const projectCode = location.state?.projectCode;
  const projectName = location.state?.projectName;
  const items = location.state?.items;
  const selectedSubIndex = location.state?.selectedSubIndex;

  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = () => {
    history.goBack();
  };

  const [typeInScreen, setTypeInScreen] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const [listData, setListData] = useState([]);
  const [listHover, setListHover] = useState(false);
  const [asc_ProductPartid, setAsc_ProductPartid] = useState("");
  const [asc_Itemdescription, setAsc_Itemdescription] = useState("");

  useEffect(() => {
    fetchScreenTranslations("Order Picking").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  useEffect(() => {
    if ((selectedSubIndex === 0 || selectedSubIndex > 0) && items?.phaseId)
      dispatch(FetchMaterialList(items.phaseId));
  }, [dispatch, items?.phaseId, selectedSubIndex]);

  useEffect(() => {
    if (items?.phaseMaterials && !selectedSubIndex) {
      setListData(items.phaseMaterials);
    }
  }, [items?.phaseMaterials, selectedSubIndex]);

  const fetchMaterialListRes = useSelector(
    (state) => state.user.fetchMaterialListRes
  );

  useEffect(() => {
    if (
      fetchMaterialListRes?.status &&
      selectedSubIndex !== undefined &&
      selectedSubIndex !== null
    ) {
      const phaseMaterialsList =
        fetchMaterialListRes?.data?.[0]?.phaseMaterials || [];

      // Filter materials and pick only the specific indexed materialQuantity
      const selectedMaterials = phaseMaterialsList
        .map((material) => {
          const matchedMaterialQuantity =
            material?.materialQuantity?.[selectedSubIndex];
          return matchedMaterialQuantity
            ? { ...material, materialQuantity: [matchedMaterialQuantity] } // Keep only matched quantity
            : null;
        })
        .filter(Boolean); // Remove null values
      // const updatedMaterials = selectedMaterials.map((material) => {
      //   return {
      //     ...material,
      //     currentQuantity: material.materialQuantity[0].currentQuantity,
      //     unit: material.materialQuantity[0].unit,
      //   };
      // });
      setListData(selectedMaterials);
    }
  }, [dispatch, fetchMaterialListRes, selectedSubIndex]);

  useEffect(() => {
    if (addOrderPickingRes?.status) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `Great Job! The product was picked for the project.`,
        },
        false
      );
      dispatch({
        type: ADD_ORDER_PICKING,
        data: {},
      });
      handleCancel();
    } else if (addOrderPickingRes?.status === false) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `something went wrong!`,
        },
        false
      );
      dispatch({
        type: ADD_ORDER_PICKING,
        data: {},
      });
    }
  }, [addOrderPickingRes?.status, dispatch, history, projectId]);

  const handleOrderPicking = () => {
    if (
      listData
        .filter((x) => x.isCheck)
        .some(
          (item) =>
            item.qtyToPick >
              (item.instock?.quantity ?? item?.currentQuantity ?? 0) ||
            item.qtyToPick > item.currentQuantity ||
            item.qtyToPick === 0 ||
            (item.instock?.quantity === 0 ??
              item?.currentQuantity === 0 ??
              0) ||
            item.currentQuantity === 0
        )
    ) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `please adjust qty to pick according to a stock.`,
        },
        false
      );
      return;
    }
    let payload = listData
      .filter((x) => x.isCheck && x.qtyToPick > 0)
      .map((x) => ({
        productid: x.materialId,
        orderproductqty: x.qtyToPick,
      }));

    dispatch(AddOrderPicking(projectId, "", payload));
  };

  // asc for disable Add Button start.
  let disableData = listData?.length && listData?.some((x) => x.isCheck);
  // asc for disable Add Button end.

  const handleQtyToPickChange = (e, item) => {
    e.preventDefault();
    const { value } = e.target;
    const newValue = Number(value);
    if (
      newValue > (item.instock?.quantity ?? item?.currentQuantity ?? 0) ||
      newValue > item.currentQuantity
    ) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `You can't pick more than stock quantity and QtyToPick ${item.currentQuantity}`,
        },
        false
      );
      return;
    }
    let data = [...listData];
    let productIndex = data.findIndex(
      (arg) => arg.materialId === item.materialId
    );
    data[productIndex]["qtyToPick"] = newValue;
    data[productIndex]["isCheck"] = true;
    setListData(data);
  };

  return (
    <mainSection>
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div className="d-flex flex-wrap gap-4 ps-4">
            <p
              className="projectText pointer mb-0"
              style={{ display: "flex", alignItems: "center" }}
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </p>
            <div
              className="d-flex pe-3 rounded"
              style={{
                background: "#FFFFFF",
                alignItems: "center",
              }}
            >
              <p className="ps-4 projectText2">
                Order Picking |{" "}
                <span className="orderCode mb-0">
                  ID &nbsp;{projectCode} {projectName}
                </span>
              </p>
            </div>
          </div>
        }
      />

      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeInScreen !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // if (typeInScreen !== "") {
          //   if (
          //     !["/stock"].includes(location.pathname)
          //   ) {
          //     return true;
          //   }
          // }
          return false;
        }}
      />

      <headerSection>
        <div className="ps-5 d-flex gap-5 flex-wrap">
          <div
            className="d-flex gap-5 justify-content-between"
            style={{ width: "38%" }}
          >
            <div className="d-flex gap-3 pt-3">
              <p className="sortBy">Work</p>
              <p className="datetext">{items.phaseName}</p>
            </div>
            <div className="d-flex gap-3 pt-3">
              <p className="sortBy">Total KG</p>
              <p className="datetext">{items.total}</p>
            </div>
          </div>

          <div className="ms-auto me-1 me-sm-5 d-flex flex-wrap gap-3 pt-2 threeButtons">
            <button
              className="mb-0 cancelBtn"
              onClick={() => {
                if (typeInScreen !== "") {
                  setCancelPopupShow(true);
                } else {
                  handleCancel();
                }
              }}
            >
              Cancel
            </button>

            <button
              className="mb-0 makeInvoBtn"
              style={{
                cursor: disableData === false ? "not-allowed" : "pointer",
              }}
              disabled={disableData === false}
              onClick={() => {
                handleOrderPicking();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </headerSection>

      <tableSection>
        <section className="pt-3">
          <div
            className="ascTableWrapper pt-3 mx-5"
            style={{ borderRadius: "15px" }}
          >
            <table className="table">
              <thead>
                <tr
                  className="tableHeading-NewInvoice"
                  style={{
                    borderBottom: "0.5px solid #a5a5a569",
                    top: "-16px",
                    zIndex: "9",
                  }}
                >
                  <th className="ps-5" style={{ width: "35%" }}>
                    {/* {FetchTranslationList[30]?.translation} */}
                    Item Name
                  </th>
                  <th style={{ width: "15%" }}>
                    {t("Item Id")}
                  </th>
                  <th style={{ width: "15%" }}>
                    Kg
                    {/* {FetchTranslationList[19]?.translation} */}
                  </th>
                  <th style={{ width: "15%" }}>
                    {t("In Stock")}
                  </th>
                  <th style={{ width: "10%" }}>
                    {t("Aisle")}
                  </th>
                  <th style={{ width: "10%" }}>
                    {t("Row")}
                  </th>
                  <th style={{ width: "10%" }}>
                    {t("Bin")}
                  </th>
                  <th className="text-end pe-4">
                    {/* {FetchTranslationList[21]?.translation} */}
                    Qty to Pick
                  </th>
                </tr>
              </thead>

              <tbody
                className="tabLine"
                style={{ borderTop: "none", background: "white" }}
              >
                {listData?.length > 0 &&
                  listData.map((item, index) => {
                    return (
                      <tr
                        style={{ borderColor: "#e8e0e0" }}
                        key={index}
                        className="TableRowClass bg-transparent"
                      >
                        <td className="ps-5">
                          <div
                            className="d-flex gap-1"
                            style={{ position: "relative" }}
                          >
                            <input
                              class="form-check-input pointer"
                              type="checkbox"
                              id="ascInvoice"
                              checked={item?.isCheck ? true : false}
                              onClick={(e) => {
                                let data = [...listData];
                                let productIndex = data.findIndex(
                                  (arg) => arg.materialId === item.materialId,
                                );
                                data[productIndex]["isCheck"] =
                                  e.target.checked;
                                data[productIndex]["qtyToPick"] =
                                  item.currentQuantity;
                                setListData(data);
                              }}
                            />
                            <textHoverSection>
                              {listHover &&
                                asc_ProductPartid === item?.materialId &&
                                item?.materialName?.length > 30 && (
                                  <div className="textHoverSection">
                                    <h6>
                                      {item?.materialName?.length > 30 &&
                                        asc_Itemdescription}
                                    </h6>
                                  </div>
                                )}
                            </textHoverSection>
                            <p
                              onMouseEnter={() => {
                                setListHover(true);
                                setAsc_ProductPartid(item?.materialId);
                                setAsc_Itemdescription(item?.materialName);
                              }}
                              onMouseLeave={() => {
                                setListHover(false);
                                setAsc_ProductPartid("");
                                setAsc_Itemdescription("");
                              }}
                            >
                              {item?.materialName?.length > 30
                                ? item?.materialName?.slice(0, 30) + "..."
                                : item?.materialName}
                            </p>
                          </div>
                        </td>
                        <td>{item.articalNumber}</td>
                        <td>{item.unit}</td>
                        <td>
                          {item?.instock?.quantity ??
                            item?.currentQuantity ??
                            0}
                        </td>
                        <td>{item.aisle}</td>
                        <td>{item.row}</td>
                        <td>{item.bin}</td>
                        <td
                          className="text-end pe-4"
                          style={{
                            background: "#FAFAFA",
                          }}
                        >
                          <input
                            className={
                              item.isCheck
                                ? "highlightedInput text-end"
                                : "orderPickInput text-end"
                            }
                            type="number"
                            min="0"
                            value={
                              item?.qtyToPick ?? item?.currentQuantity ?? 0
                            }
                            onChange={(e) => handleQtyToPickChange(e, item)}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          {/* {listData.length > 0 && (
            <div className="mx-5">
              <Pagination
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </div>
          )} */}
        </section>
      </tableSection>
    </mainSection>
  );
};

export default OrderPickingFromProject;
